import styled from 'styled-components';
import { variables } from 'styleUtils';

export const Container = styled.div.attrs(({ bgColor }) => {
	const props = {
		background: variables.yellow,
	}

	if (bgColor && variables[bgColor]) {
		props.background = variables[bgColor];
	}
	return props;
})`
  background: ${props => props.background};
  font-size: 12px;
  padding: 20px;
  margin-top: 20px;
  margin-left: 20px;
  border-radius: 6px;
  position: relative;
  color: ${variables.darkGrey};

  &::before {
    content: "";
    position: absolute;
    font-family: "GT-Pressura", Courier, serif;
    text-transform: uppercase;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 20px 20px 0 20px;
    border-color: ${props => props.background} transparent transparent transparent;
    top: 0;
    left: -20px;
  }
`;
